module.exports = __webpack_public_path__ + "static/img/mhaibao3.de42f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/mhaibao3.png
// module id = ngVf
// module chunks = 0